import * as THREE from "three";
import { buildTank } from "./tank";
import { createProjectilePrimitive } from "./primitives";

/**
 * Provides entity meshes. Tanks use the modular low-poly builder (shadows,
 * separable turret, per-player color). The Quaternius GLB path is parked — the
 * FBX2glTF v0.9.7 conversion rendered mis-oriented with no separable turret.
 */
export class AssetLoader {
  getTank(color: number): THREE.Group {
    return buildTank(color);
  }

  getProjectile(ricochet = false): THREE.Mesh {
    return createProjectilePrimitive(ricochet);
  }
}
